import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AlertController, Platform, PopoverController } from '@ionic/angular';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/services/customFormValidators';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-popover-reconfirmation',
  templateUrl: './popover-reconfirmation.component.html',
  styleUrls: ['./popover-reconfirmation.component.scss'],
})
export class PopoverReconfirmationComponent implements OnInit {

  public reconfirmForm: FormGroup;
  public isPepOrHio: boolean = false;
  public customer: CustomerModel;
  isMobileApp:boolean = false;

  public reconfirm;

  constructor(
    public alertController: AlertController,
    private commonAlertService: CommonAlertService,
    private userSessionService: UserSessionService,
    private navigator: Navigator,
    private authenticationService: AuthenticationService,
    public popOverCtrl: PopoverController,
    public loginService: LoginService,
    private platform: Platform,
    private logoutService: LogoutService
  ) { }

  ngOnInit() {
    this.isMobileApp = this.platform.is('capacitor');
    localStorage.setItem("reconfirmPopover","true");
    this.reconfirmForm = new FormGroup({
      checkboxGroup: new FormGroup({
        fullName: new FormControl(false),
        address: new FormControl(false),
        phoneNumber: new FormControl(false),
        occupation: new FormControl(false),
      }, requireCheckboxesToBeCheckedValidator()),
      pepHio: new FormControl(false),
    });

    this.reconfirm = 'no';

    this.userSessionService.getCustomer().subscribe(
      (customer) => {
        if (customer) {
          this.customer = customer;
          this.isPepOrHio = this.customer.getCustomDataProperty('IS_PEP_OR_HIO') === 'true';
          this.reconfirmForm.get('pepHio').setValue(this.isPepOrHio);
        }
      }, (err) => {
        console.error("getCustomer", err);
      }
    );
  }

  onChangeRecord(event) {
    this.reconfirm = event;
  }


  async showInfo() {
    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      message: '<ol><li>Select this if you hold or have held, within the last 5 years, a specific office or position in or on behalf of the Canadian federal government, a Canadian provincial (or territorial) government, or a Canadian municipal government. Example: Governor General/member of Senate or House of Commons or legislature/deputy minister/military office with rank of General or above; head of government agency/ambassador or attaché/judge of a court/leader of political party or mayor. (OR)</li><li>If you hold or have ever held similar positions for a foreign country (OR)</li><li>If you hold or have held within the last 5 years, a specific office or position of head of an international organization which is established by the government of states or by an international organization.</li></ol>',
      buttons: [
        {
          text: 'Close',
          role: 'yes',
        }
      ],
      backdropDismiss: false
    });
    await alert.present();
  }

  showPepHioInfo() {
    let data = {
      isPEPOrHIO: this.reconfirmForm.get('pepHio').value
    }
    let messageText = 'You have changed your PEP/HIO Status. Someone from support will reach out to you to help with the next steps.';
    this.userSessionService.updateAccount("" + this.customer.customerId, data);
    this.commonAlertService.showPepHioAlert(messageText, () => this.logoutService.onLogout());

  }

  onContinue(){
    if(this.reconfirm === "yes"){
        this.closePopover('yes');
        localStorage.removeItem("reconfirmPersonalDetails");
        this.navigator.navigateTo("PersonalInformationComponent", { forceModal: true }, { reconfirmPersonalInfo: true });
    }
    if(this.reconfirm === "no"){
      this.closePopover('no');
    }
  }

  onSubmit() {
    if (this.reconfirmForm.get('pepHio').value !== this.isPepOrHio) {
      this.showPepHioInfo();
    } else {
      this.navigator.navigateTo("PersonalInformationComponent", { forceModal: true }, { reconfirmPersonalInfo: true });
    }
    this.closePopover('NO');
  }

  closePopover(val) {
    if (val == 'no') {
      localStorage.removeItem("reconfirmPopover");
      this.loginService.clearCustomerReconfirmationPersonalInfo();
      this.authenticationService.callReconfirmCustomerDetails(false);
    }
    this.popOverCtrl.dismiss(true);
  }

}
